import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/ps4_raffle_elgiganten.webp";
import RaffleUIPlayStation from "@/features/raffle/components/raffle.ui.ps";

const RafflePage: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Raffle");

  return (
    <>
      <CoverImage
        src={Image}
        alt="CoverImage"
        heading="Find en vinder af PS konkurrencen"
        desc="Klik på knappen for at finde en vinder."
      />
      <RaffleUIPlayStation />
    </>
  );
};

export default RafflePage;
